import { render, staticRenderFns } from "./FeePreferences.vue?vue&type=template&id=3dcb3310"
import script from "./FeePreferences.vue?vue&type=script&lang=js"
export * from "./FeePreferences.vue?vue&type=script&lang=js"
import style0 from "./FeePreferences.vue?vue&type=style&index=0&id=3dcb3310&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports